
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 .7H3C1.8.7.8 1.7.8 2.9v18c0 1.2 1 2.2 2.2 2.2h18c1.2 0 2.2-1 2.2-2.2V3c0-1.2-1-2.3-2.2-2.3zM2.2 3c0-.4.3-.8.8-.8h18c.4 0 .8.3.8.8v3.8H2.2V3zm19.6 5.2v4.1H2.2V8.2h19.6zM21 21.7H3c-.4 0-.8-.3-.8-.8v-7.1h19.5V21c.1.4-.3.7-.7.7z"}})])
          )
        }
      }
    